// extracted by mini-css-extract-plugin
export default {"root":"SectorKPIsTableHead_root__7Frvg"};